@let blok = block();
<ng-template #content>
    <p
        class="m-0 text-xl md:text-3xl font-bold group-hover:text-primary whitespace-nowrap">
    <span
        class="hidden md:inline">{{ tariffStore.tariff$() | titlecase }}</span> {{ blok.textContent }}
    </p>
    <span
        class="flex w-10 h-10 rounded-full bg-white group-hover:bg-primary justify-center items-center p-1">
    <mat-icon
        aria-hidden="false"
        aria-label="Icon"
        class="!block !h-16 !w-auto !max-w-16"
        svgIcon="right_arrow" />
  </span>
</ng-template>




@if (blok.link?.length) {
    <button (click)="scrollToTarget()"
            (keydown)="scrollToTarget()"
            tabindex="-1"
            [class.is-visible]="(tariffStore.tariff$() && tariffStore.size$() && button.active$ | async)"
            class="px-0.5 py-0.5 bg-white app-tariff-order-button rounded-full">
        <div
            class="button-with-dot group bg-primary hover:bg-white group-hover:bg-white flex flex-shrink-0 rounded-full border border-solid border-secondary p-button-with-dot justify-center items-center gap-4 md:gap-6 hover:border hover:border-solid text-white py-2 pl-6 md:pl-12 pr-2">
            <ng-container
                *ngTemplateOutlet="content">
            </ng-container>
        </div>
    </button>
} @else {
    <a
        [href]="tariffStore.tariff$() === 'single' ? tariffStore.size$() === 'basic' ? blok.linkSingleBasic?.cached_url : tariffStore.size$() === 'comfort' ? blok.linkSingleComfort?.cached_url : blok.linkSinglePremium?.cached_url : tariffStore.size$() === 'basic' ? blok.linkFamilyBasic?.cached_url : tariffStore.size$() === 'comfort' ? blok.linkFamilyComfort?.cached_url : blok.linkFamilyPremium?.cached_url"
        [class.is-visible]="(tariffStore.tariff$() && tariffStore.size$() && button.active$ | async)"
        class="px-0.5 py-0.5 bg-white app-tariff-order-button rounded-full">
        <div
            class="button-with-dot group bg-primary hover:bg-white group-hover:bg-white flex flex-shrink-0 rounded-full border border-solid border-secondary p-button-with-dot justify-center items-center gap-4 md:gap-6 hover:border hover:border-solid text-white py-2 pl-6 md:pl-12 pr-2">
            <ng-container
                *ngTemplateOutlet="content">
            </ng-container>
        </div>
    </a>
}

